var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtNblanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 346.79 294.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.38,268.05c0,3.26-1.86,4.98-5.08,4.98s-5.3-1.54-5.3-4.98v-8.25h1.72v8.25c0,2.28,1.3,3.53,3.58,3.53s3.36-1.25,3.36-3.53v-8.25h1.72v8.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.11 259.8 14.94 259.8 21.73 270.28 21.77 270.28 21.77 259.8 23.4 259.8 23.4 272.72 21.52 272.72 14.77 262.35 14.73 262.35 14.73 272.72 13.11 272.72 13.11 259.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.25,
    y: 259.8,
    width: 1.71,
    height: 12.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.95 272.72 33.99 272.72 29.43 259.8 31.29 259.8 34.99 271 35.02 271 38.75 259.8 40.54 259.8 35.95 272.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.91 259.8 50.83 259.8 50.83 261.25 43.63 261.25 43.63 265.35 50.34 265.35 50.34 266.8 43.63 266.8 43.63 271.27 50.88 271.27 50.88 272.72 41.91 272.72 41.91 259.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.95,259.8h6.08c2.43,0,3.92,1.32,3.92,3.39,0,1.55-.69,2.84-2.24,3.27v.04c1.5.29,1.81,1.39,1.94,2.66.11,1.27.03,2.68.76,3.57h-1.92c-.49-.53-.21-1.92-.47-3.19-.18-1.26-.49-2.34-2.15-2.34h-4.2v5.53h-1.72v-12.93ZM58.26,265.75c1.61,0,2.99-.42,2.99-2.3,0-1.27-.69-2.21-2.3-2.21h-4.27v4.51h3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.81,263.58c-.2-1.85-1.43-2.64-3.2-2.64-1.45,0-2.9.52-2.9,2.21,0,1.59,2.06,1.83,4.15,2.29,2.06.47,4.12,1.2,4.12,3.73,0,2.76-2.69,3.86-5.05,3.86-2.89,0-5.33-1.41-5.33-4.56h1.63c0,2.18,1.81,3.11,3.76,3.11,1.55,0,3.27-.49,3.27-2.35s-2.06-2.08-4.12-2.53c-2.06-.46-4.14-1.05-4.14-3.43,0-2.62,2.33-3.78,4.69-3.78,2.64,0,4.65,1.25,4.75,4.09h-1.63Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.13,
    y: 259.8,
    width: 1.72,
    height: 12.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.74,259.8h4.43c3.98,0,6.21,1.99,6.21,6.16s-1.91,6.77-6.21,6.77h-4.43v-12.93ZM83.46,271.27h2.86c1.17,0,4.34-.33,4.34-5.09,0-3.08-1.14-4.94-4.31-4.94h-2.89v10.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.98,259.8h1.9l5.05,12.93h-1.9l-1.41-3.89h-5.47l-1.44,3.89h-1.78l5.05-12.93ZM96.69,267.38h4.38l-2.15-6.03h-.04l-2.19,6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.19,259.8h4.44c3.98,0,6.2,1.99,6.2,6.16s-1.9,6.77-6.2,6.77h-4.44v-12.93ZM107.91,271.27h2.86c1.18,0,4.34-.33,4.34-5.09,0-3.08-1.14-4.94-4.31-4.94h-2.89v10.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "126.88 261.25 122.57 261.25 122.57 259.79 132.9 259.79 132.9 261.25 128.59 261.25 128.59 272.72 126.88 272.72 126.88 261.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.32 259.8 143.24 259.8 143.24 261.25 136.04 261.25 136.04 265.35 142.75 265.35 142.75 266.8 136.04 266.8 136.04 271.27 143.3 271.27 143.3 272.72 134.32 272.72 134.32 259.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.45,263.69c-.36-1.83-1.83-2.75-3.62-2.75-3.07,0-4.38,2.53-4.38,5.23,0,2.95,1.31,5.42,4.4,5.42,2.26,0,3.57-1.6,3.73-3.73h1.72c-.33,3.22-2.34,5.18-5.59,5.18-4.01,0-5.97-2.97-5.97-6.74s2.14-6.81,6.12-6.81c2.69,0,4.92,1.45,5.32,4.2h-1.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "158.41 259.8 160.23 259.8 167.03 270.28 167.07 270.28 167.07 259.8 168.7 259.8 168.7 272.72 166.82 272.72 160.07 262.35 160.03 262.35 160.03 272.72 158.41 272.72 158.41 259.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.94,259.49c4.11,0,6.19,3.26,6.19,6.77s-2.08,6.77-6.19,6.77-6.18-3.26-6.18-6.77,2.08-6.77,6.18-6.77M176.94,271.58c3.15,0,4.47-2.72,4.47-5.32s-1.32-5.33-4.47-5.33-4.46,2.72-4.46,5.33,1.32,5.32,4.46,5.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "185.22 259.8 186.94 259.8 186.94 271.27 193.77 271.27 193.77 272.72 185.22 272.72 185.22 259.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.73,259.49c4.11,0,6.19,3.26,6.19,6.77s-2.08,6.77-6.19,6.77-6.18-3.26-6.18-6.77,2.08-6.77,6.18-6.77M200.73,271.59c3.15,0,4.47-2.72,4.47-5.32s-1.32-5.33-4.47-5.33-4.47,2.72-4.47,5.33,1.32,5.32,4.47,5.32M201.19,256.28h1.96l-2.37,2.59h-1.15l1.55-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.67,271.11c-.99,1.36-2.62,1.92-4.14,1.92-3.86,0-6.15-3.15-6.15-6.52,0-3.77,2.06-7.03,6.15-7.03,2.82,0,5.06,1.27,5.55,4.3h-1.72c-.34-1.96-1.91-2.84-3.83-2.84-3.13,0-4.43,2.71-4.43,5.48s1.55,5.17,4.43,5.17c2.66,0,4.25-1.87,4.14-4.22h-4.12v-1.44h5.67v6.81h-1.08l-.46-1.61Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 222.81,
    y: 259.8,
    width: 1.72,
    height: 12.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.5,263.69c-.36-1.83-1.82-2.75-3.62-2.75-3.07,0-4.38,2.53-4.38,5.23,0,2.95,1.3,5.42,4.4,5.42,2.26,0,3.56-1.6,3.72-3.73h1.72c-.32,3.22-2.34,5.18-5.59,5.18-4.01,0-5.97-2.97-5.97-6.74s2.13-6.81,6.11-6.81c2.69,0,4.92,1.45,5.32,4.2h-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.98,259.8h1.9l5.04,12.93h-1.9l-1.41-3.89h-5.47l-1.44,3.89h-1.77l5.04-12.93ZM242.7,267.38h4.38l-2.15-6.03h-.03l-2.19,6.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "257.2 259.8 259.02 259.8 265.83 270.28 265.86 270.28 265.86 259.8 267.49 259.8 267.49 272.72 265.61 272.72 258.87 262.35 258.83 262.35 258.83 272.72 257.2 272.72 257.2 259.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.79,259.8h1.9l5.05,12.93h-1.9l-1.41-3.89h-5.46l-1.45,3.89h-1.78l5.05-12.93ZM272.5,267.38h4.37l-2.15-6.03h-.03l-2.18,6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.07,263.69c-.36-1.83-1.83-2.75-3.62-2.75-3.07,0-4.38,2.53-4.38,5.23,0,2.95,1.31,5.42,4.4,5.42,2.26,0,3.56-1.6,3.73-3.73h1.72c-.32,3.22-2.34,5.18-5.59,5.18-4.01,0-5.97-2.97-5.97-6.74s2.14-6.81,6.12-6.81c2.7,0,4.92,1.45,5.31,4.2h-1.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 295.11,
    y: 259.8,
    width: 1.72,
    height: 12.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.19,259.49c4.11,0,6.19,3.26,6.19,6.77s-2.08,6.77-6.19,6.77-6.19-3.26-6.19-6.77,2.08-6.77,6.19-6.77M305.19,271.58c3.15,0,4.47-2.72,4.47-5.32s-1.32-5.33-4.47-5.33-4.46,2.72-4.46,5.33,1.31,5.32,4.46,5.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "313.45 259.8 315.28 259.8 322.08 270.28 322.11 270.28 322.11 259.8 323.74 259.8 323.74 272.72 321.86 272.72 315.12 262.35 315.08 262.35 315.08 272.72 313.45 272.72 313.45 259.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.03,259.8h1.9l5.05,12.93h-1.9l-1.41-3.89h-5.46l-1.45,3.89h-1.77l5.04-12.93ZM328.75,267.38h4.38l-2.15-6.03h-.03l-2.19,6.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "338.24 259.8 339.96 259.8 339.96 271.27 346.79 271.27 346.79 272.72 338.24 272.72 338.24 259.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.79 281.52 22.27 281.52 22.27 282.97 15.5 282.97 15.5 287.07 21.44 287.07 21.44 288.53 15.5 288.53 15.5 294.45 13.79 294.45 13.79 281.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.68,281.52h1.9l5.05,12.93h-1.9l-1.41-3.89h-5.47l-1.44,3.89h-1.77l5.05-12.93ZM25.39,289.1h4.38l-2.15-6.03h-.04l-2.19,6.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.96,285.41c-.36-1.83-1.82-2.75-3.62-2.75-3.07,0-4.38,2.53-4.38,5.23,0,2.96,1.3,5.42,4.4,5.42,2.26,0,3.56-1.59,3.72-3.73h1.72c-.32,3.22-2.33,5.17-5.58,5.17-4.02,0-5.97-2.97-5.97-6.73s2.13-6.81,6.11-6.81c2.69,0,4.92,1.45,5.31,4.2h-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.25,289.77c0,3.26-1.86,4.98-5.08,4.98s-5.3-1.53-5.3-4.98v-8.26h1.72v8.26c0,2.28,1.3,3.53,3.58,3.53s3.36-1.25,3.36-3.53v-8.26h1.72v8.26Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.99 281.52 62.71 281.52 62.71 293 69.55 293 69.55 294.45 60.99 294.45 60.99 281.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.31 282.97 68.01 282.97 68.01 281.52 78.34 281.52 78.34 282.97 74.03 282.97 74.03 294.44 72.31 294.44 72.31 282.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.61,281.52h1.9l5.05,12.93h-1.9l-1.41-3.89h-5.46l-1.45,3.89h-1.77l5.05-12.93ZM80.32,289.1h4.38l-2.15-6.03h-.03l-2.19,6.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.82,281.52h4.43c3.98,0,6.21,1.99,6.21,6.15s-1.9,6.78-6.21,6.78h-4.43v-12.93ZM91.53,293h2.86c1.18,0,4.34-.33,4.34-5.09,0-3.08-1.14-4.94-4.31-4.94h-2.89v10.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.57,281.52h6.08c2.42,0,3.92,1.32,3.92,3.38,0,1.56-.68,2.84-2.24,3.28v.04c1.5.29,1.81,1.39,1.94,2.66.11,1.26.04,2.68.76,3.57h-1.92c-.48-.52-.21-1.92-.46-3.19-.18-1.26-.49-2.34-2.16-2.34h-4.19v5.52h-1.72v-12.93ZM112.87,287.48c1.61,0,2.98-.42,2.98-2.3,0-1.27-.68-2.21-2.3-2.21h-4.27v4.51h3.58Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.96 281.52 128.88 281.52 128.88 282.97 121.68 282.97 121.68 287.07 128.38 287.07 128.38 288.53 121.68 288.53 121.68 293 128.93 293 128.93 294.45 119.96 294.45 119.96 281.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.66,292.83c-.99,1.36-2.62,1.92-4.14,1.92-3.85,0-6.15-3.15-6.15-6.51,0-3.77,2.06-7.03,6.15-7.03,2.82,0,5.07,1.27,5.56,4.29h-1.72c-.34-1.96-1.91-2.84-3.83-2.84-3.13,0-4.43,2.72-4.43,5.48s1.55,5.16,4.43,5.16c2.66,0,4.25-1.86,4.14-4.22h-4.12v-1.45h5.66v6.81h-1.09l-.45-1.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.8,
    y: 281.52,
    width: 1.72,
    height: 12.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.87,281.21c4.11,0,6.19,3.26,6.19,6.77s-2.08,6.78-6.19,6.78-6.19-3.27-6.19-6.78,2.08-6.77,6.19-6.77M154.87,293.3c3.15,0,4.47-2.72,4.47-5.32s-1.32-5.32-4.47-5.32-4.47,2.72-4.47,5.32,1.32,5.32,4.47,5.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "163.13 281.52 164.96 281.52 171.76 292 171.8 292 171.8 281.52 173.42 281.52 173.42 294.45 171.54 294.45 164.8 284.07 164.76 284.07 164.76 294.45 163.13 294.45 163.13 281.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.72,281.52h1.9l5.04,12.93h-1.9l-1.41-3.89h-5.47l-1.45,3.89h-1.77l5.04-12.93ZM178.43,289.1h4.38l-2.15-6.03h-.04l-2.18,6.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "187.92 281.52 189.64 281.52 189.64 293 196.48 293 196.48 294.45 187.92 294.45 187.92 281.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.01,281.52h4.68c1.14,0,2.64,0,3.42.47.85.51,1.51,1.43,1.51,2.7,0,1.37-.72,2.4-1.91,2.89v.04c1.59.32,2.46,1.52,2.46,3.11,0,1.9-1.35,3.72-3.92,3.72h-6.24v-12.93ZM204.72,287.07h3.44c1.95,0,2.75-.7,2.75-2.06,0-1.8-1.26-2.05-2.75-2.05h-3.44v4.11ZM204.72,293h4.3c1.49,0,2.43-.9,2.43-2.32,0-1.69-1.35-2.15-2.8-2.15h-3.93v4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.7,289.77c0,3.26-1.86,4.98-5.09,4.98s-5.3-1.53-5.3-4.98v-8.26h1.72v8.26c0,2.28,1.3,3.53,3.58,3.53s3.36-1.25,3.36-3.53v-8.26h1.72v8.26Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "228.45 281.52 237.36 281.52 237.36 282.97 230.16 282.97 230.16 287.07 236.87 287.07 236.87 288.53 230.16 288.53 230.16 293 237.42 293 237.42 294.45 228.45 294.45 228.45 281.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "239.47 281.52 241.3 281.52 248.1 292 248.14 292 248.14 281.52 249.77 281.52 249.77 294.45 247.89 294.45 241.14 284.07 241.1 284.07 241.1 294.45 239.47 294.45 239.47 281.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.01,281.21c4.11,0,6.18,3.26,6.18,6.77s-2.08,6.78-6.18,6.78-6.19-3.27-6.19-6.78,2.08-6.77,6.19-6.77M258.01,293.3c3.14,0,4.47-2.72,4.47-5.32s-1.32-5.32-4.47-5.32-4.47,2.72-4.47,5.32,1.33,5.32,4.47,5.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.76,285.3c-.2-1.85-1.43-2.64-3.2-2.64-1.45,0-2.9.52-2.9,2.2s2.07,1.83,4.14,2.3c2.06.47,4.13,1.2,4.13,3.73,0,2.75-2.69,3.86-5.05,3.86-2.89,0-5.33-1.41-5.33-4.56h1.63c0,2.17,1.81,3.11,3.76,3.11,1.55,0,3.27-.49,3.27-2.35s-2.06-2.08-4.12-2.53c-2.06-.45-4.15-1.06-4.15-3.42,0-2.63,2.34-3.78,4.69-3.78,2.64,0,4.65,1.25,4.75,4.09h-1.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.54,281.52h1.91l5.04,12.93h-1.9l-1.41-3.89h-5.45l-1.45,3.89h-1.77l5.04-12.93ZM285.25,289.1h4.38l-2.15-6.03h-.03l-2.2,6.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 294.82,
    y: 281.52,
    width: 1.72,
    height: 12.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.43,281.52h6.08c2.42,0,3.92,1.32,3.92,3.38,0,1.56-.69,2.84-2.24,3.28v.04c1.5.29,1.81,1.39,1.93,2.66.11,1.26.04,2.68.76,3.57h-1.92c-.49-.52-.21-1.92-.47-3.19-.18-1.26-.49-2.34-2.15-2.34h-4.2v5.52h-1.72v-12.93ZM304.73,287.48c1.61,0,2.99-.42,2.99-2.3,0-1.27-.69-2.21-2.29-2.21h-4.27v4.51h3.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.82 281.52 320.73 281.52 320.73 282.97 313.53 282.97 313.53 287.07 320.25 287.07 320.25 288.53 313.53 288.53 313.53 293 320.78 293 320.78 294.45 311.82 294.45 311.82 281.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.33,285.3c-.2-1.85-1.42-2.64-3.2-2.64-1.45,0-2.89.52-2.89,2.2s2.06,1.83,4.14,2.3c2.06.47,4.12,1.2,4.12,3.73,0,2.75-2.69,3.86-5.04,3.86-2.89,0-5.33-1.41-5.33-4.56h1.62c0,2.17,1.82,3.11,3.77,3.11,1.55,0,3.27-.49,3.27-2.35s-2.06-2.08-4.13-2.53c-2.05-.45-4.14-1.06-4.14-3.42,0-2.63,2.34-3.78,4.68-3.78,2.64,0,4.65,1.25,4.76,4.09h-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.28,130.41c-32.91,0-59.69-26.81-59.69-59.76s26.78-59.75,59.69-59.75,59.69,26.8,59.69,59.75-26.77,59.76-59.69,59.76M173.28,14.1c-31.15,0-56.49,25.37-56.49,56.55s25.34,56.56,56.49,56.56,56.5-25.37,56.5-56.56-25.34-56.55-56.5-56.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.28,141.3c-38.92,0-70.57-31.69-70.57-70.65S134.36,0,173.28,0s70.58,31.69,70.58,70.65-31.66,70.65-70.58,70.65M173.28,3.2c-37.15,0-67.38,30.25-67.38,67.45s30.23,67.45,67.38,67.45,67.38-30.26,67.38-67.45S210.43,3.2,173.28,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.24,66.04h-22.78c13.35-3.12,22.73-15.35,22.73-27.47,0-.44-.02-.9-.04-1.34h-11.33c0,.13,0,.26,0,.39,0,8.03-5.49,14.79-13,16.92v-17.31h-9.98v17.31c-7.5-2.12-12.99-8.89-12.99-16.92,0-.13,0-.26,0-.39h-11.25c-.02.44-.04.9-.04,1.34,0,12.24,9.31,24.37,22.62,27.47h-22.68v10.12h22.92c-13.43,3.01-22.86,15.21-22.86,27.52,0,.45.02.9.04,1.35h11.25c0-.13,0-.27,0-.4,0-8.02,5.49-14.79,12.99-16.91v17.16h9.98v-17.16c7.5,2.12,13,8.89,13,16.91,0,.14,0,.27,0,.4h11.33c.02-.45.04-.9.04-1.35,0-12.19-9.5-24.5-22.97-27.52h23.02v-10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.06,172.73h11.78v39.24c0,9.05.57,19.53,15.83,19.53s15.83-10.47,15.83-19.53v-39.24h11.78v43.11c0,17.26-11.03,25.85-27.61,25.85S.06,233.1.06,215.84v-43.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.9,240.18h-11.78v-39.24c0-9.06-.57-19.53-15.83-19.53s-15.83,10.47-15.83,19.53v39.24h-11.78v-43.1c0-17.26,11.03-25.85,27.61-25.85s27.61,8.58,27.61,25.85v43.1Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.96 172.73 119.42 172.73 119.42 182.91 98.03 182.91 98.03 240.08 86.26 240.08 86.26 182.91 64.96 182.91 64.96 172.73"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.03,230.46h-20.83v-48.11h19.22c6.41,0,9.89,2.45,9.89,9.24,0,6.03-4.23,9.35-9.89,9.35h-19.86v8.48h21.47c7.16,0,11.3,3.78,11.3,10.37s-4.14,10.66-11.3,10.66M266.48,203.95v-.19c6.12-2.64,9.61-7.55,9.61-14.34,0-11.22-7.91-16.69-19.98-16.69h-32.7v67.35h30.91c17.43,0,24.78-8.21,24.78-18.77,0-9.15-4.43-15.57-12.62-17.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.06,213.29v-12.34c0-9.05.56-19.53,15.83-19.53s15.83,10.48,15.83,19.53v12.34h-31.66ZM318.9,171.23c-16.59,0-27.61,8.58-27.61,25.85v43.1h11.78v-17.91h31.66v17.91h11.78v-43.1c0-17.27-11.03-25.85-27.61-25.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.48,226.8c2.07,0,3.86.76,5.35,2.25,1.49,1.51,2.23,3.3,2.23,5.38s-.74,3.84-2.22,5.29c-1.48,1.45-3.27,2.18-5.36,2.18s-3.97-.71-5.38-2.12c-1.4-1.41-2.1-3.2-2.1-5.39s.73-3.91,2.19-5.39c1.46-1.47,3.22-2.21,5.3-2.21"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtNblanco);
export default __webpack_public_path__ + "static/media/UTN blanco.ac5346bf90e502a31a6e3fabfa70b5a2.svg";
export { ForwardRef as ReactComponent };